import { CSSProperties } from 'react';

import UIConfig from '@/UIConfig';

export const profileContainer: CSSProperties = {
  height: 'calc(100vh - 100px)',
  background: UIConfig.Colors.BackgroundDark,
  overflowY: 'auto',
  overscrollBehavior: 'none'
};

export const containerWrapper: CSSProperties = {
  width: '100vw',
  overflow: 'auto',
  marginBottom: 40,
  background: UIConfig.Colors.BackgroundDark
};

export const photoBlock: CSSProperties = {
  position: 'relative',
  height: 550,
  width: '100%',
  overflow: 'hidden',
  borderBottomRightRadius: UIConfig.Card.Content.borderRadius
};

export const photo: CSSProperties = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  borderBottomRightRadius: UIConfig.Card.Content.borderRadius,
  position: 'absolute',
  top: 0,
  left: 0
};

export const unmatchAction: CSSProperties = {
  color: 'white',
  display: 'flex',
  fontWeight: 'bold',
  justifyContent: 'center',
  alignItems: 'center'
};

export const reportAction: CSSProperties = {
  color: '#f70505',
  display: 'flex',
  fontWeight: 'bold',
  justifyContent: 'center',
  alignItems: 'center'
};
